<template>
  <div class="card" style="width: 500px">
    <div class="card-modal">
      <b-loading
        :is-full-page="true"
        v-model="loading"
        :can-cancel="false"
      ></b-loading>

      <header class="modal-card-head">
        <p class="modal-card-title">                  Assign Travel Policy
</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
       <b-notification
            type="is-warning is-light"
            :closable="false"
            role="alert">
The selected travel policy will apply to <b>{{selectedContacts.length}}</b> contacts        </b-notification>
            <b-field >

            <template #label>
                Select Travel Policy
               
            </template>
            <b-select
                        
                        placeholder="Select Travel Policy" v-model="selectedTravelPolicy"
                        expanded
                      >
                        <option value="">--None--</option>
                        <option
                          v-for="option in policies"
                          :value="option.id"
                          :key="option.id"
                        >
                          {{ option.ruleClass }}
                        </option>
                      </b-select>
                    </b-field>
        <br />
      </section>
      <footer class="modal-card-foot">
        <b-button label="Close" @click="$emit('close')" />
      
        <b-button
          :disabled="!isFormValid"
          @click="assignTravelPolicy()"
          class="button is-primary is-wide"
        >
          Assign Travel Policy </b-button
        >
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssignTravelPolicyModal',
   props: {
     selectedContacts:Array,
    policies:Array


    },
  data(){
      return{
         
          loading:false,
          selectedTravelPolicy:'',            

  }
          
      
  },
  methods: {
    
      
    assignTravelPolicy(){
        this.loading=true;
        var body = {
            "accountId": this.activeUser.account.id,
            "contactId":this.activeUser.id,
            "travelPolicyId":this.selectedTravelPolicy,
            "listOfContacts":this.selectedContacts
            }

             this.$app.huddleLabsServerCall('profile/assign-travel-policy', body)
            .then(result => {
                if(result.success){
                    this.success();
                    this.loading=false;
                    this.$emit('close');     
                    this.$emit('save-success');

                }else{
                    this.failure();
                    this.loading=false;
                    this.$emit('close')

                }

            })


    },

     
        success()
            {
                this.$buefy.toast.open({
                    message: 'Travel policy  sucessfully assigned.',
                    type: 'is-success'
                })
            },
        failure() 
            {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: 'There was an error assigning travel policy.',
                    position: 'is-bottom',
                    type: 'is-danger'
                })
            }
},
mounted(){

},
  computed:
  {
     isFormValid(){
            
                return (this.selectedTravelPolicy.length>0);

        },
         activeUser() {
          return this.$store.getters['app/getActiveUser'];
        },
        isTravelChampion(){
          if(this.activeUser)
            return this.activeUser.isTravelChampion;
          return false;
        }
      
     


  }
}
</script>

<style scoped>
.is-less-bottom {
  margin-bottom: -20px;
}

.section-heading {
  font-size: 25px;
  margin-bottom: 10px;
  display: block;
  padding: 8px 8px;
  border-bottom: 2px solid;
  margin-bottom: 10px;
}
</style>
